<template>
  <div class="contract-discount">
    <b-form-group label-align-md="left" class="required-control">
      <label>Loại thanh toán:</label>
      <b-form-select
        class="select-style"
        v-model="contractData.paymentType"
        size="sm"
        :disabled="isDisabled"
      >
        <b-form-select-option value="INSTALLMENT">
          Trả góp
        </b-form-select-option>
        <b-form-select-option value="DIRECTLY">
          Trả thẳng
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group>
      <label>Chiết khấu</label>
      <b-input-group>
        <BInputNumber
          size="sm"
          class="text-right"
          id="input-discount"
          v-model="contractData.totalDiscountAmount"
          :disabled="isDisabled"
          :allow-decimal="
            selectDiscountType === DISCOUNT_AMOUNT_TYPE.PERCENT
          "
        />
        <template #append>
          <b-button
            size="sm"
            style="width: 40px"
            variant="secondary"
            :title="discountTypeLabel"
            :aria-label="discountTypeLabel"
            @click="onChangeDiscountType"
            :disabled="isDisabled"
          >
            <i
              v-if="selectDiscountType === DISCOUNT_AMOUNT_TYPE.PERCENT"
              class="fa fa-percent"
              aria-hidden="true"
            ></i>
            <i v-else class="fas fa-dollar-sign" aria-hidden="true"></i>
          </b-button>
        </template>
      </b-input-group>
    </b-form-group>
    <!-- Tổng trước/sau chiết khấu đã hiển thị ở footer bảng "Thông tin sản phẩm" -->
  </div>
</template>

<script>
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
import { convertPrice, calTotalDiscount } from '@/utils/common';
import { unMaskPrice } from '../../../utils/common';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';

// import {

//     makeToastFaile,
//     makeToastSuccess,
//     unMaskPrice,
// } from '@/utils/common';
export default {
  components: { BInputNumber },
  props: ['contractData', 'isDisabled'],
  data() {
    return {
      DISCOUNT_AMOUNT_TYPE,
      selectDiscountType: 'AMOUNT',
    };
  },
  computed: {
    totalAmountBeforeAfterDiscount() {
      return this.calTotalAmountBeforeAfterDiscount(
        this.contractData,
        this.contractData.contractDetail,
      );
    },
    discountTypeLabel() {
      return this.selectDiscountType === DISCOUNT_AMOUNT_TYPE.PERCENT
        ? 'Phần trăm — bấm để chuyển sang Tiền mặt'
        : 'Tiền mặt — bấm để chuyển sang Phần trăm';
    },
  },
  mounted() {
    if (this.contractData) {
      this.selectDiscountType = this.contractData.discountType;
    }
  },
  methods: {
    convertPrice,
    calTotalDiscount,
    calTotalAmountBeforeAfterDiscount(
      discountContract,
      discountContractDetail,
    ) {
      const { discountType, totalDiscountAmount } = discountContract;

      let totalBeforeDiscount = 0,
        totalAfterDiscount = 0;

      for (let i = 0; i < discountContractDetail.length; i++) {
        const item = discountContractDetail[i];
        totalBeforeDiscount = totalBeforeDiscount + Number(item['totalAmount']);
      }

      totalAfterDiscount = calTotalDiscount(totalBeforeDiscount, {
        discountType,
        discountAmount: unMaskPrice(totalDiscountAmount),
      });

      return { totalBeforeDiscount, totalAfterDiscount };
    },
    onChangeDiscountType() {
      // dảo ngược loại chiết khấu
      this.selectDiscountType =
        this.selectDiscountType === this.DISCOUNT_AMOUNT_TYPE.PERCENT
          ? this.DISCOUNT_AMOUNT_TYPE.MONEY
          : this.DISCOUNT_AMOUNT_TYPE.PERCENT;
      this.contractData.discountType = this.selectDiscountType;
    },
  },
};
</script>

<style></style>
